import React from "react";
import i18n, { t } from "i18next";
import { availableLanguages } from "../i18n";
import styles from "./Switch.component.module.css";
import usersApi from "../../api/user/user";

const SwitchComponent: React.FC = () => {
  // i18next fallbackLng interno drži kao NIZ (npr. ["SR"]), a select trazi
  // običan tekst - inače React ispisuje upozorenje u konzoli
  const fallback = i18n.options.fallbackLng;
  const fallbackLang = Array.isArray(fallback)
    ? String(fallback[0])
    : typeof fallback === "string"
      ? fallback
      : "SR";
  const currentLang = availableLanguages.includes(i18n.language)
    ? i18n.language
    : fallbackLang;

  return (
    <div className={styles.container}>
      <select
        className={styles.select}
        value={currentLang}
        onChange={(e) => {
          localStorage.setItem("i18n_user_chose", "true");
          usersApi.changeLanguageByCurrentUser(e.target.value).catch(()=>{})
          return i18n.changeLanguage(e.target.value)}}
      >
        <option value="" disabled>
          {`${t("Jezik")}`}
        </option>

        {availableLanguages.map((language) => (
          <option key={language} value={language}>
            {language.toUpperCase()}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SwitchComponent;
